import { postUrl } from '../fetch';

import { IAutoLoginResponse } from './autoLoginTypes';

export async function autoLogin(
    token: string
): Promise<IAutoLoginResponse | undefined> {
    const url = '/api/user/auto-login';

    console.log('autoLogin - calling API with token:', token);

    const response = await postUrl<IAutoLoginResponse>(url, { token });

    console.log('autoLogin - response:', response);

    if (response) {
        return response;
    } else {
        console.error('Error auto-login:', response);
        return undefined;
    }
}
